export default [
  {
    key: 'tilbud',
    position: 'top',
    attribute: 'taxonomies.Tjeneste',
    copyKey: 'typeOfHome',
    copySelect: 'chooseType',
  },
  {
    key: 'Fylke',
    position: 'top',
    attribute: 'taxonomies.Fylke',
    copyKey: 'region',
    copySelect: 'selectRegion',
  },
  {
    key: 'search',
    position: 'top',
    copyKey: 'searchTitle',
    copyPlaceholder: 'searchTitle',
  },
];
